import { ValueDisplay } from '../../components/ValueDisplay'
import LineDisplay from './LineDisplay'
import { Input } from "baseui/input";
import { LabelMedium } from 'baseui/typography';
import { Block } from 'baseui/block';
import { IControlledShiftFunction4Point } from './types'

// api
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { FormattedMessage } from 'react-intl';



export const OperatorPanel = (props: IControlledShiftFunction4Point) => {

    return (

        <>
            <>
                <ValueDisplay value={props.actSetpoint} dimension={'°C'}></ValueDisplay>
            </>
            <LineDisplay {...props}> </LineDisplay>
        </>
    )
}

